import { h } from 'vue';

import { props, computed } from './mixin';

export default {
    inheritAttrs: false,

    mixins: [props, computed],

    methods:
    {
        updateValue(event)
        {
            this.$emit('update:modelValue', event.target.value);
        }
    },

    render()
    {
        // const vm = this;

        return h(
            'div',

            {
                class: [
                    this.wrapperClasses,

                    this.divClass
                ],
            },

            [
                Boolean(this.label) && h(
                    'label',

                    {
                        class: this.labelClasses,
                    },

                    this.label
                ),
                
                !this.loading
                    ? h(
                        'textarea',
    
                        {
                            class: this.classes,

                            cols: this.cols,

                            rows: this.rows,
    
                            ...this.$attrs,
    
                            value: this.modelValue,
    
                            onInput: (event) => this.$emit('update:modelValue', event.target.value),
    
                            // onKeyup: (event) => vm.$emit('keyup', event.target.value),
                        }
                    )
                    : h(
                        'vh-placeholder',
                        {
                            class:
                            [
                                'vh-placeholder',
                                `vh-placeholder-bar`,
                                `vh-placeholder-bar-medium`,
                                'vh-animate',
                                'vh-animate-infinite',
                                'vh-animate-shimmer',
                            ],
                            
                            style:
                            {
                                width: '100%',
                                // height: 'auto',
                            },
                        }
                    ),
                

                Boolean(this.error) && h(
                    'small',

                    {
                        class: 'vh-text-danger vh-text-bold',
                    },

                    [
                        h(
                            'i',

                            {
                                class: 'ti ti-info-alt vh-margin-xsmall-right'
                            },
                        ),

                        this.error
                    ]
                ),
            ]
        );
    },
};
